import React from "react";
import AppBloc from "./blocs/AppBloc";

export const AppBlocContext = React.createContext(null);
